import styled from "styled-components";
import { lightThemeColors } from "../../assets/styles/colors";

export const Container = styled.div`
  display: grid;
  grid-template-rows: auto 1fr;
  height: 100%;
  width: 100%;
  background: #fafafa;
  overflow: hidden;
`;

export const Title = styled.h2`
  color: ${lightThemeColors.darkColor};
  font-size: 20px;
  font-weight: 800;
  line-height: 1;
  margin: 0;
`;

export const Badge = styled.span`
  padding: 2px 8px;
  border-radius: 999px;
  font-size: 11px;
  font-weight: 700;
  background: ${(props) =>
    props.tone === "brand" ? lightThemeColors.primaryColor : "rgba(56,56,58,0.1)"};
  color: ${(props) => (props.tone === "brand" ? "#fff" : lightThemeColors.darkColor)};
`;

export const Grid = styled.div`
  display: grid;
  gap: 20px;
  grid-template-columns: repeat(12, 1fr);
  align-items: start;

  @media (max-width: 1024px) {
    grid-template-columns: 1fr;
  }
`;

export const Card = styled.section`
  background: #fff;
  border: 1px solid rgba(0, 0, 0, 0.05);
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.04);
  border-radius: 14px;
  padding: 18px;
  grid-column: ${(props) => (props.$span2 ? "span 12" : "span 6")};

  @media (max-width: 1024px) {
    grid-column: 1 / -1;
  }
`;

export const Note = styled.p`
  color: rgba(56, 56, 58, 0.75);
  font-size: 13px;
  line-height: 1.6;
  margin: 4px 0 14px;

  a {
    color: ${lightThemeColors.primaryColor};
  }
`;

export const Mono = styled.code`
  font-family: "Menlo", ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas,
    "Liberation Mono", "Courier New", monospace;
  font-size: 0.95em;
`;

export const CodeArea = styled.pre`
  font-family: "Menlo", ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas,
    "Liberation Mono", "Courier New", monospace;
  font-size: 12.5px;
  line-height: 1.45;
  padding: 14px;
  margin: 0;
  max-width: 100%;
  overflow: auto;
  white-space: pre;
  word-break: normal;

  code {
    font-family: inherit;
  }
`;

export const EndpointLabel = styled.div`
  color: #059669;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.5px;
  flex-shrink: 0;
  background: #d1fae5;
  padding: 8px 12px;
  border-radius: 6px;
  border: 1px solid #a7f3d0;
`;

export const HeaderRow = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  justify-content: space-between;
  padding: 16px 24px;
  background: #fff;
  border-bottom: 1px solid rgba(0, 0, 0, 0.05);
  position: sticky;
  top: 0;
  z-index: 1;
`;

export const HeaderMeta = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 10px;
`;

export const Small = styled.span`
  font-size: 12px;
  color: rgba(56, 56, 58, 0.7);
`;

export const DividerDot = styled.span`
  width: 4px;
  height: 4px;
  background: rgba(56, 56, 58, 0.35);
  border-radius: 50%;
  display: inline-block;
`;

export const PageContent = styled.div`
  overflow: auto;
  padding: 24px;
`;

export const CardHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  justify-content: space-between;
  margin-bottom: 12px;
`;

export const CardTitle = styled.h3`
  color: ${lightThemeColors.darkColor};
  font-size: 16px;
  font-weight: 800;
  margin: 0;
`;

export const List = styled.div`
  display: grid;
  gap: 10px;
`;

export const Item = styled.div`
  display: grid;
  grid-template-columns: 180px 1fr;
  gap: 12px;

  @media (max-width: 560px) {
    grid-template-columns: 1fr;
  }
`;

export const Key = styled.div`
  color: ${lightThemeColors.darkColor};
  font-weight: 700;
  font-size: 13px;
  background: #f5f5f5;
  padding: 6px 10px;
  border-radius: 6px;
  border: 1px solid rgba(0, 0, 0, 0.06);
  width: fit-content;
`;

export const Desc = styled.div`
  color: rgba(56, 56, 58, 0.9);
  font-size: 13px;
  line-height: 1.6;
`;

export const EndpointRow = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  margin-bottom: 16px;
`;

export const EndpointValue = styled.div`
  color: ${lightThemeColors.darkColor};
  font-size: 14px;
  font-weight: 600;
  word-break: break-all;
  font-family: "Menlo", ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas,
    "Liberation Mono", "Courier New", monospace;
`;

export const CodeBlock = styled.div`
  border: 1px solid rgba(255, 255, 255, 0.15);
  background: rgba(34, 39, 46, 1);
  color: #fff;
  border-radius: 12px;
  overflow: hidden;
`;

export const Toolbar = styled.div`
  display: flex;
  align-items: center;
  padding: 10px 12px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.08);
  background: rgba(255, 255, 255, 0.03);
`;

export const LangPill = styled.span`
  font-size: 11px;
  font-weight: 800;
  letter-spacing: 0.4px;
  background: rgba(72, 165, 240, 0.18);
  color: rgba(72, 165, 240, 1);
  border: 1px solid rgba(72, 165, 240, 0.35);
  padding: 4px 8px;
  border-radius: 999px;
`;

export const Spacer = styled.div`
  flex: 1;
`;

export const CopyBtn = styled.button`
  background: rgba(255, 255, 255, 0.06);
  border: 1px solid rgba(255, 255, 255, 0.12);
  color: #fff;
  font-size: 12px;
  font-weight: 800;
  padding: 6px 10px;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.15s ease;
  display: inline-flex;
  align-items: center;
  gap: 6px;

  &[data-copied="true"] {
    background: rgba(72, 165, 240, 0.2);
    border-color: rgba(72, 165, 240, 0.5);
  }

  &:hover {
    background: rgba(255, 255, 255, 0.1);
  }

  svg {
    width: 14px;
    height: 14px;
  }
`;

export const Tabs = styled.div`
  display: inline-flex;
  background: rgba(56, 56, 58, 0.06);
  border-radius: 10px;
  padding: 4px;
  gap: 4px;
`;

export const Tab = styled.button`
  border: none;
  background: transparent;
  padding: 6px 10px;
  border-radius: 8px;
  font-size: 12px;
  font-weight: 800;
  color: ${lightThemeColors.darkColor};
  cursor: pointer;
  transition: all 0.15s ease;

  &[aria-selected="true"] {
    background: #fff;
    box-shadow: 0 1px 6px rgba(0, 0, 0, 0.08);
  }
`;

export const ErrorList = styled.div`
  display: grid;
  gap: 10px;
`;

export const ErrorRow = styled.div`
  display: grid;
  grid-template-columns: 60px 1fr;
  gap: 12px;

  @media (max-width: 560px) {
    grid-template-columns: 1fr;
  }
`;

export const ErrCode = styled.div`
  font-weight: 700;
  font-size: 12px;
  letter-spacing: 0.3px;
  border-radius: 6px;
  padding: 6px 10px;
  text-align: center;
  width: fit-content;
  color: #991b1b;
  background: #fee2e2;
  border: 1px solid #fecaca;
`;

export const ErrText = styled.div`
  color: rgba(56, 56, 58, 0.9);
  font-size: 13px;
`;

export const WorkflowSteps = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const Step = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 12px;
`;

export const StepNumber = styled.div`
  background: ${lightThemeColors.primaryColor};
  color: #fff;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 800;
  font-size: 14px;
  flex-shrink: 0;
`;

export const StepContent = styled.div`
  flex: 1;
`;

export const StepTitle = styled.div`
  font-weight: 700;
  font-size: 14px;
  color: ${lightThemeColors.darkColor};
  margin-bottom: 4px;
`;

export const StepDesc = styled.div`
  font-size: 13px;
  color: rgba(56, 56, 58, 0.75);
  line-height: 1.5;
`;

export const FlowDiagram = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  padding: 20px;
  background: #f9fafb;
  border-radius: 8px;
`;

export const FlowStep = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;

export const FlowLabel = styled.div`
  font-size: 13px;
  font-weight: 600;
  color: ${lightThemeColors.darkColor};
  background: #fff;
  padding: 8px 12px;
  border-radius: 6px;
  border: 1px solid rgba(0, 0, 0, 0.08);
`;

export const FlowArrow = styled.div`
  font-size: 18px;
  color: ${lightThemeColors.primaryColor};
  font-weight: 700;
`;

export const SubTitle = styled.div`
  color: ${lightThemeColors.darkColor};
  font-size: 13px;
  font-weight: 800;
  margin: 16px 0 10px;
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const StatusPill = styled.span`
  font-size: 11px;
  font-weight: 800;
  letter-spacing: 0.3px;
  color: #059669;
  background: #d1fae5;
  border: 1px solid #a7f3d0;
  padding: 3px 8px;
  border-radius: 6px;
`;

const Pill = styled.span`
  display: inline-block;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.2px;
  padding: 2px 9px;
  border-radius: 999px;
  margin-right: 8px;
  white-space: nowrap;
  vertical-align: 1px;
`;

export const RequiredBadge = styled(Pill)`
  color: #b45309;
  background: #fef3c7;
  border: 1px solid #fde68a;
`;

export const OptionalBadge = styled(Pill)`
  color: #059669;
  background: #d1fae5;
  border: 1px solid #a7f3d0;
`;

export const Callout = styled.p`
  color: #92400e;
  background: #fffbeb;
  border: 1px solid #fde68a;
  border-radius: 8px;
  padding: 12px 14px;
  font-size: 13px;
  line-height: 1.6;
  margin: 16px 0 14px;
`;
